const NoMatchingFabrics = () => (
	<div className="border-2 h-full w-full my-10 pb-4">
		<p className="py-36 text-center font-weight font-bold text-2xl">
			No matching fabrics found.
		</p>
	</div>
);

export default NoMatchingFabrics;
